'use strict';

require('../../style/index.less');

require('../../layout/style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/col/style/index.tsx
 ** module id = 332
 ** module chunks = 0
 **/